module.exports = __webpack_public_path__ + "static/5-Jar detail back-4709d6a33feb570f6ab007b2473bc5c2.jpg";